import Navigation from '../../../components/layout/Navigation';
import Footer from '../../../components/layout/Footer';
import Hero from '../../../components/ui/Hero';
import Section from '../../../components/ui/Section';
import FeatureGrid from '../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../components/ui/ProcessTimeline';
import CTA from '../../../components/ui/CTA';

export default function AIGoogleAdsPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Google Ads, Driven by <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-indigo-400 bg-clip-text text-transparent">Intelligence</span></>}
        description="We leverage advanced AI to transform your Google Ads into a precision-targeted, high-performing growth engine."
        bgImage="/assets/modern-ai-powered-dashboard.png"
        primaryBtn={{ text: "Optimize Ads", link: "/contact", icon: "ri-google-fill" }}
        secondaryBtn={{ text: "Success Stories", link: "/work", icon: "ri-arrow-right-line" }}
      />

      <Section>
        <FeatureGrid 
          title={<>The Next Evolution of <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Search Advertising</span></>}
          subtitle="AI Integrated Google Ads Campaigns use advanced tools to automate and optimize, providing deeper insights and better performance."
          items={[
            { title: 'Predictive Bidding', description: 'AI predicts optimal bids to maximize conversions.', icon: 'ri-auction-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Dynamic Creative', description: 'AI generates optimized ad copy messaging.', icon: 'ri-edit-2-line', color: 'from-purple-500 to-pink-500' },
            { title: 'Advanced Targeting', description: 'Uncover niche segments for precise targeting.', icon: 'ri-crosshair-2-line', color: 'from-indigo-500 to-purple-500' },
            { title: 'Keyword Discovery', description: 'Identify high-potential & negative keywords.', icon: 'ri-search-line', color: 'from-cyan-500 to-blue-500' },
            { title: 'Performance Forecast', description: 'Predict outcomes and detect anomalies.', icon: 'ri-line-chart-line', color: 'from-pink-500 to-red-500' }
          ]}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="Human Strategy, AI Precision"
          subtitle="We blend expert strategy with AI precision to optimize your Google Ads campaigns in real-time."
          steps={[
            { title: 'Audit', description: 'Strategic analysis & goal setting.', icon: 'ri-search-eye-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Intelligence', description: 'Keyword & audience research.', icon: 'ri-brain-line', color: 'from-cyan-500 to-teal-500' },
            { title: 'Strategy', description: 'Creative & landing page setup.', icon: 'ri-palette-line', color: 'from-teal-500 to-green-500' },
            { title: 'Launch', description: 'Intelligent campaign setup.', icon: 'ri-rocket-line', color: 'from-green-500 to-blue-500' },
            { title: 'Optimization', description: 'Continuous monitoring & reporting.', icon: 'ri-line-chart-line', color: 'from-blue-500 to-purple-500' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Ready to Dominate <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent">Google Ads with AI?</span></>}
        description="Let's Make Your Ads Work Smarter, Not Just Harder. Partner with Hash Adz to unlock the full potential of AI-powered Google Ads."
        primaryBtn={{ text: "Start Campaign", link: "/contact" }}
        secondaryBtn={{ text: "View Results", link: "/work" }}
        stats={[
          { number: '750+', label: 'Campaigns' },
          { number: '98%', label: 'Satisfaction' },
          { number: '$50M+', label: 'Spend Optimized' }
        ]}
      />

      <Footer />
    </div>
  );
}